import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTabAttachments = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" fillRule="evenodd" d="M10 2a1 1 0 0 0-1 1v9H7V3a3 3 0 0 1 6 0v8a5 5 0 0 1-10 0V3.5h2V11a3 3 0 1 0 6 0V3a1 1 0 0 0-1-1" clipRule="evenodd" />
  </svg>
);
export default SvgTabAttachments;
